export default __webpack_public_path__ + "static/media/jp.d4734872.svg";